import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
// TODO: file unit test nya mana
// TODO: udah ada di shared
@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {
  uuid = uuidv4();

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}


  getDeviceId(): string | undefined {
    let returnId;
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('deviceId')) {
        returnId = localStorage.getItem('deviceId') as string;
      } else {
        const randomId = uuidv4();
        returnId = randomId;
        localStorage.setItem('deviceId', randomId);
      }
    }
    return returnId;
  }
}
